import { render, staticRenderFns } from "./TestIdentityNumbers.vue?vue&type=template&id=09ddd14f&"
import script from "./TestIdentityNumbers.vue?vue&type=script&lang=js&"
export * from "./TestIdentityNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports